// extracted by mini-css-extract-plugin
export var icon = "_76-1";
export var subtext = "_76-0";